import { useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

export default function SaveCoverModal({
  open,
  onClose,
  onSave,
  defaultCoverName,
}) {
  const { t } = useTranslation()
  const [coverName, setCoverName] = useState('')

  useEffect(() => {
    setCoverName(defaultCoverName || 'My Cover')
  }, [defaultCoverName])

  return (
    <Modal backdrop={false} show={open} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t('save_as')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Control
              type="input"
              placeholder={t('your_template_name')}
              className="mb-3"
              value={coverName}
              onChange={(e) => {
                setCoverName(e.target.value)
              }}
              autoFocus
            />
          </Form.Group>
          {coverName && (
            <Button
              variant="primary"
              type="submit"
              onClick={(e) => {
                e.preventDefault() // TODO: Make this not a Form.
                onSave(coverName)
              }}
            >
              {t('save')}
            </Button>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  )
}
